import { User } from '@wellesley/openapi'
import { useState } from 'react'
import { authSlice } from '@wellesley/auth'
import { useSelector } from 'react-redux'
import GuestFollowModal from 'components/modals/GuestFollowModal'
import {
  FollowMutationCommonProps,
  usePostApiV1UsersFollowByUsernameMutation,
  usePostApiV1UsersFollowByUsernameUndoMutation,
} from '@wellesley/user'

import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'

type HookProps = {
  user: User
  onFollow?(): void
  onUnfollow?(): void
  unsubscribe?: boolean
}

const useFollow = ({ user, onFollow, onUnfollow, unsubscribe }: HookProps) => {
  const [isGuestFollowOpen, setGuestFollowOpen] = useState(false)

  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)

  const [handleFollow] = usePostApiV1UsersFollowByUsernameMutation()
  const [handleUnfollow] = usePostApiV1UsersFollowByUsernameUndoMutation()

  const domain = user?.domain

  const commonProps: FollowMutationCommonProps = {
    user,
    username: getUserNameWithDomain(user),
    ...(domain && { domain }),
  }

  const follow = async () => {
    isLogged ? await handleFollow(commonProps) : setGuestFollowOpen(true)

    void onFollow?.()
  }

  const unfollow = async () => {
    await handleUnfollow({
      mutual: unsubscribe,
      ...commonProps,
    })

    void onUnfollow?.()
  }

  const renderGuestFollowModal = () =>
    isGuestFollowOpen ? (
      <GuestFollowModal
        user={user}
        open={isGuestFollowOpen}
        onCloseModal={() => setGuestFollowOpen(false)}
      />
    ) : null

  return { follow, unfollow, renderGuestFollowModal }
}

export default useFollow
